import { ReactNode } from 'react';

import { PaymentMethod } from '../../../../../../common/payment';

import applePayImage from '../../../../../../assets/applepay.png';
import paypalImage from '../../../../../../assets/paypal.png';
import visaImage from '../../../../../../assets/visa.png';

export const PAYMENT_METHOD_TO_DISPLAY: { [key in PaymentMethod]: ReactNode } =
  {
    [PaymentMethod.SavedCreditCard]: (
      <>
        <img src={visaImage} alt="visa" /> **** 4824
      </>
    ),
    [PaymentMethod.ApplePay]: <img src={applePayImage} alt="Apple Pay" />,
    [PaymentMethod.Paypal]: <img src={paypalImage} alt="paypal" />,
    [PaymentMethod.NewCreditCard]: <div>Add a new card</div>,
  };
